import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import utilsView from "../../../../engines/libs/utilsView";
import { GeneralKind } from "../../../define/GeneralKind";
import { UIKind } from "../../../define/UIKind";
import { BUNDLE_SMALL_NAME, getOneBundleOnePrefab } from "../../BundleResourceConfig";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class investStockStartPage extends cc.Component {

    @property({type:cc.Node,displayName:"漕运节点"})
    caoNode:cc.Node = null;

    onLoad(): void {
        this.caoNode.on("touchstart",this.onTouchStart,this);
        this.caoNode.on("touchend",this.onTouchEnd,this);
        this.caoNode.on("touchcancel",this.onTouchEnd,this);

        O1HD.getModules().uiControlModule.hideLoading();
        if (!utilsView.enterLayerDispose(UIKind.UILayerTag.XH, this.node)) {
            this.onGiveAway();
        }
    }

    onTouchStart(e:cc.Event.EventTouch){
        let targetNode:cc.Node = e.target;
        let light:cc.Node = targetNode.getChildByName("light");
        light.active = true;
    }

    onTouchEnd(e:cc.Event.EventTouch){
        let targetNode:cc.Node = e.target;
        let light:cc.Node = targetNode.getChildByName("light");
        light.active = false;
    }

    onBtnJiJin(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        getOneBundleOnePrefab(BUNDLE_SMALL_NAME.investStockGameBundle,"prefab/investStock").then((prefab:cc.Prefab)=>{
            if(prefab){
                let node:cc.Node = cc.instantiate(prefab);
                node.setParent(O1HD.Canvas());
            }
        });
    }

    onGiveAway() {
        let gameData = NormalGameManager._instance.getGameData();
        let lastTime = gameData.lastRecvWaterTransport;
        let curTime = Date.now();
        if (!data_control.isNextDay(curTime, lastTime)) {
            return;
        }
        gameData.lastRecvWaterTransport = curTime;
        NormalGameManager._instance.onPushGoods(
            GeneralKind.PropId.WATER_TRANSPORT_CARD_ID
            , GeneralKind.GeneralValue.EVENT_DAY_WATER_TRANSPORT
        );
        NormalGameManager._instance.writeGameData();
    }

    closeThis(){
        this.node.destroy();
        this.node.removeFromParent();
    }

    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.closeThis();
    }

    onDisable(){
        O1HD.emit("normalMode.onBackNormal", UIKind.UILayerTag.XH);
    }
}
